import "jquery-ui/ui/i18n/datepicker-fr";
import "jquery-ui/ui/i18n/datepicker-de";

import "jquery-ui/ui/widgets/datepicker";
import "jquery-timepicker/jquery.timepicker";

import "jquery-ui/themes/base/datepicker.css";
import "jquery-timepicker/jquery.timepicker.css";
import { action } from "../utils/requests";

export default {
	name: 'FormConsulting',
	data() {
		return {
			fields: {
				Company: "",
				email: "",
				phone: "",
				name: "",
				reward: "",
				date: "",
				hour: "",
				appointment: "",
			},
			submiting: false,
		};
	},
	mounted() {
		$.datepicker.setDefaults($.datepicker.regional[this.$store.state.lang]);

		$(this.$el)
			.find(".calendar")
			.datepicker({
				dateFormat: "yy/mm/dd",
				beforeShowDay: $.datepicker.noWeekends,
				numberOfMonths: 2,
				firstDay: 1,
				onSelect: (dateText) => {
					let date = new Date(dateText);
					this.fields.date = date.valueOf() / 1000;
				},
			}).datepicker('setDate', '2')

		var timepicker = $(this.$el)
			.find(".timepicker")
			.keydown(function (e) {
				e.preventDefault();
			})
			.timepicker({
				minTime: '08:00',
				maxTime: '17:30',
				change: (time) => {
					this.fields.hour = timepicker.timepicker("format", time);
				},
			});
	},
	methods: {
		submitForm() {
			if (this.submiting) {
				return;
			}

			this.submiting = true;
			action("save_form", {
				fields: this.fields,
				form: "consulting",
			}).then((res) => {
				this.resetForm();
				this.submiting = false;
			});
		},
		resetForm() {
			this.fields = {
				email: "",
				phone: "",
				name: "",
				reward: "",
				date: "",
				hour: "",
				appointment: "",
			};
		},
	},
}
